import Gallery from './ComposedGallery';
import query from './GalleryQuery.graphql';

Gallery.query = query;

export default Gallery;
